import { render } from "./ExplanationElement.vue?vue&type=template&id=030295d4&scoped=true"
import script from "./ExplanationElement.vue?vue&type=script&lang=js"
export * from "./ExplanationElement.vue?vue&type=script&lang=js"

import "./ExplanationElement.vue?vue&type=style&index=0&id=030295d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-030295d4"]])

export default __exports__